import { IOpChangeState, IJsonSerializable } from '../util/interfaces'
import { Enums } from '../common/enums'
import { OpCurrency } from '../core/op-currency'
import { OpDepositoryElement } from '../core'

export class OpTaskPaymentElement implements IOpChangeState, IJsonSerializable {

    //#region Properties
    
    public paymentType: Enums.TaskPaymentType
    public elementType: Enums.TaskPaymentPartType
    public defaultValue: number
    public value: number
    public notes: string
    public description: string
    public element: OpDepositoryElement
    public indexNbr: number
    public opState: Enums.OpChangeState
    public currency: OpCurrency

    //#endregion

    //#region Ctor

    constructor(opObj: any = null) {
        this.fromJSON(opObj)
    }

    //#endregion


    //#region IJsonSerializable Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.description = opObj.Description
            this.indexNbr = opObj.IndexNbr
            this.notes = opObj.Notes
            this.opState = opObj.OpState
            this.paymentType = opObj.PaymentType
            this.value = opObj.Value

            this.elementType = opObj.ElementType
            this.defaultValue = opObj.DefaultValue

            this.element = opObj.Element != null ? new OpDepositoryElement(opObj.Element) : null

            this.currency = opObj.Currency != null ? new OpCurrency(opObj.Currency) : null
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            Description: this.description,
            IndexNbr: this.indexNbr,
            Notes: this.notes,
            OpState: this.opState,
            PaymentType: this.paymentType,
            Value: this.value,
            ElementType: this.elementType,
            DefaultValue: this.defaultValue,
            Element: this.element != null ? this.element.toJSON() : null,
            Currency: this.currency != null ? this.currency.toJSON() : null
        }
    }

    //#endregion


    //#region toString

    public toString() {
        return this.description
    }

    //#endregion
}